import { apiClient, API_ENDPOINTS } from '@dukene/shared';

export interface ReceiptConfiguration {
  businessName: string;
  branchName: string;
  branchNo: string;
  tillNo: string;
  contactAddress: string;
  contactPhone: string;
  contactEmail: string;
  vatPin: string;
  kraCuNo: string;
  kraCuInvNo: string;
  kraRctRefNo: string;
  kraQrData: string;
  footerNote: string;
  tagline: string;
  logoUrl: string;
  logoMarkUrl: string;
}

export const DEFAULT_RECEIPT_CONFIGURATION: ReceiptConfiguration = {
  businessName: 'Dukene Merchant Store',
  branchName: 'Main Retail Branch',
  branchNo: '01',
  tillNo: '01',
  contactAddress: 'Nairobi, Kenya',
  contactPhone: '+254 700 000 000',
  contactEmail: 'support@dukene.co.ke',
  vatPin: 'P000000000X',
  kraCuNo: 'KRACU000001',
  kraCuInvNo: 'INV0001',
  kraRctRefNo: 'REF0001',
  kraQrData: 'https://itax.kra.go.ke/KRA-Portal',
  footerNote: 'Thank you for shopping with us!',
  tagline: 'Empowering Next-Gen Commerce',
  logoUrl: '/logo.svg',
  logoMarkUrl: '/logo-mark.svg',
};

export async function loadReceiptConfiguration(_locationId?: string): Promise<ReceiptConfiguration> {
  try {
    const store = await apiClient.get<any>(API_ENDPOINTS.MERCHANT.STORE);
    if (store && store.settings?.receiptConfig) {
      return { ...DEFAULT_RECEIPT_CONFIGURATION, ...store.settings.receiptConfig };
    }
    return {
      ...DEFAULT_RECEIPT_CONFIGURATION,
      businessName: store?.name || DEFAULT_RECEIPT_CONFIGURATION.businessName,
      contactPhone: store?.phone || DEFAULT_RECEIPT_CONFIGURATION.contactPhone,
      contactEmail: store?.email || DEFAULT_RECEIPT_CONFIGURATION.contactEmail,
    };
  } catch {
    return DEFAULT_RECEIPT_CONFIGURATION;
  }
}
